export enum COMMON_ACTION_TYPES {
    INIT_MOBILE_CHECK = '[COMMON] Check for mobile',
    MOBILE_CHECK_SUCCESS = '[COMMON effect] set isMobile flag'
}
